import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';

import { LanguageService } from '@app/shared/services/language.service';

@Component({
    selector: 'languages',
    templateUrl: './languages.component.html',
    encapsulation: ViewEncapsulation.None,
    exportAs: 'languages',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LanguagesComponent implements OnInit, OnDestroy {

    constructor(public languageService: LanguageService) {
    }

    get primaryLanguages() {
        const primaryKeys = ['tr', 'en', 'es', 'it', 'de'];
        return this.languageService.availableLanguages?.filter(x => x && primaryKeys.includes(x.key)) || [];
    }

    get otherLanguages() {
        const primaryKeys = ['tr', 'en', 'es', 'it', 'de'];
        const others = this.languageService.availableLanguages?.filter(x => !primaryKeys.includes(x.key) && x.key && x.key !== 'separator') || [];
        return others.sort((a, b) => a.title.localeCompare(b.title));
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {

    }

}
